// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminSplatRouteImport } from './routes/_admin.$'
import { Route as AdminAccountIntegrationRouteImport } from './routes/_admin.account-integration'
import { Route as AdminBidManagementRouteImport } from './routes/_admin.bid-management'
import { Route as AdminDashboardRouteImport } from './routes/_admin.dashboard'
import { Route as AdminInventoryUploadRouteImport } from './routes/_admin.inventory-upload'
import { Route as AdminSettingsRouteImport } from './routes/_admin.settings'
import { Route as AdminUserManagementRouteImport } from './routes/_admin.user-management'
import { Route as AdminInvoiceIndexRouteImport } from './routes/_admin.invoice.index'
import { Route as AdminInvoiceNewRouteImport } from './routes/_admin.invoice.new'
import { Route as AdminOrderManagementIndexRouteImport } from './routes/_admin.order-management.index'
import { Route as AdminOrderManagementOrderIdRouteImport } from './routes/_admin.order-management.$orderId'
import { Route as AdminWarehouseIndexRouteImport } from './routes/_admin.warehouse.index'
import { Route as AdminCrmClientsIndexRouteImport } from './routes/_admin.crm.clients.index'
import { Route as AdminCrmOpportunitiesIndexRouteImport } from './routes/_admin.crm.opportunities.index'
import { Route as AdminInvoiceInvoiceIdIndexRouteImport } from './routes/_admin.invoice.$invoiceId.index'
import { Route as AdminInvoiceInvoiceIdEditRouteImport } from './routes/_admin.invoice.$invoiceId.edit'
import { Route as AdminInvoiceInvoiceIdPdfRouteImport } from './routes/_admin.invoice.$invoiceId.pdf'
import { Route as AdminInvoiceCreditMemoNewRouteImport } from './routes/_admin.invoice.credit-memo.new'
import { Route as AdminWarehouseOrdersOrderIdRouteImport } from './routes/_admin.warehouse.orders.$orderId'
import { Route as AdminInvoiceCreditMemoInvoiceIdIndexRouteImport } from './routes/_admin.invoice.credit-memo.$invoiceId.index'
import { Route as AdminInvoiceCreditMemoInvoiceIdEditRouteImport } from './routes/_admin.invoice.credit-memo.$invoiceId.edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/_admin',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AdminSplatRoute = AdminSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AdminRoute
          })
const AdminAccountIntegrationRoute = AdminAccountIntegrationRouteImport.update({
            id: '/account-integration',path: '/account-integration',getParentRoute: () => AdminRoute
          })
const AdminBidManagementRoute = AdminBidManagementRouteImport.update({
            id: '/bid-management',path: '/bid-management',getParentRoute: () => AdminRoute
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AdminRoute
          })
const AdminInventoryUploadRoute = AdminInventoryUploadRouteImport.update({
            id: '/inventory-upload',path: '/inventory-upload',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminUserManagementRoute = AdminUserManagementRouteImport.update({
            id: '/user-management',path: '/user-management',getParentRoute: () => AdminRoute
          })
const AdminInvoiceIndexRoute = AdminInvoiceIndexRouteImport.update({
            id: '/invoice/',path: '/invoice/',getParentRoute: () => AdminRoute
          })
const AdminInvoiceNewRoute = AdminInvoiceNewRouteImport.update({
            id: '/invoice/new',path: '/invoice/new',getParentRoute: () => AdminRoute
          })
const AdminOrderManagementIndexRoute = AdminOrderManagementIndexRouteImport.update({
            id: '/order-management/',path: '/order-management/',getParentRoute: () => AdminRoute
          })
const AdminOrderManagementOrderIdRoute = AdminOrderManagementOrderIdRouteImport.update({
            id: '/order-management/$orderId',path: '/order-management/$orderId',getParentRoute: () => AdminRoute
          })
const AdminWarehouseIndexRoute = AdminWarehouseIndexRouteImport.update({
            id: '/warehouse/',path: '/warehouse/',getParentRoute: () => AdminRoute
          })
const AdminCrmClientsIndexRoute = AdminCrmClientsIndexRouteImport.update({
            id: '/crm/clients/',path: '/crm/clients/',getParentRoute: () => AdminRoute
          })
const AdminCrmOpportunitiesIndexRoute = AdminCrmOpportunitiesIndexRouteImport.update({
            id: '/crm/opportunities/',path: '/crm/opportunities/',getParentRoute: () => AdminRoute
          })
const AdminInvoiceInvoiceIdIndexRoute = AdminInvoiceInvoiceIdIndexRouteImport.update({
            id: '/invoice/$invoiceId/',path: '/invoice/$invoiceId/',getParentRoute: () => AdminRoute
          })
const AdminInvoiceInvoiceIdEditRoute = AdminInvoiceInvoiceIdEditRouteImport.update({
            id: '/invoice/$invoiceId/edit',path: '/invoice/$invoiceId/edit',getParentRoute: () => AdminRoute
          })
const AdminInvoiceInvoiceIdPdfRoute = AdminInvoiceInvoiceIdPdfRouteImport.update({
            id: '/invoice/$invoiceId/pdf',path: '/invoice/$invoiceId/pdf',getParentRoute: () => AdminRoute
          })
const AdminInvoiceCreditMemoNewRoute = AdminInvoiceCreditMemoNewRouteImport.update({
            id: '/invoice/credit-memo/new',path: '/invoice/credit-memo/new',getParentRoute: () => AdminRoute
          })
const AdminWarehouseOrdersOrderIdRoute = AdminWarehouseOrdersOrderIdRouteImport.update({
            id: '/warehouse/orders/$orderId',path: '/warehouse/orders/$orderId',getParentRoute: () => AdminRoute
          })
const AdminInvoiceCreditMemoInvoiceIdIndexRoute = AdminInvoiceCreditMemoInvoiceIdIndexRouteImport.update({
            id: '/invoice/credit-memo/$invoiceId/',path: '/invoice/credit-memo/$invoiceId/',getParentRoute: () => AdminRoute
          })
const AdminInvoiceCreditMemoInvoiceIdEditRoute = AdminInvoiceCreditMemoInvoiceIdEditRouteImport.update({
            id: '/invoice/credit-memo/$invoiceId/edit',path: '/invoice/credit-memo/$invoiceId/edit',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminSplatRoute: AdminSplatRoute,AdminAccountIntegrationRoute: AdminAccountIntegrationRoute,AdminBidManagementRoute: AdminBidManagementRoute,AdminDashboardRoute: AdminDashboardRoute,AdminInventoryUploadRoute: AdminInventoryUploadRoute,AdminSettingsRoute: AdminSettingsRoute,AdminUserManagementRoute: AdminUserManagementRoute,AdminInvoiceNewRoute: AdminInvoiceNewRoute,AdminOrderManagementOrderIdRoute: AdminOrderManagementOrderIdRoute,AdminInvoiceIndexRoute: AdminInvoiceIndexRoute,AdminOrderManagementIndexRoute: AdminOrderManagementIndexRoute,AdminWarehouseIndexRoute: AdminWarehouseIndexRoute,AdminInvoiceInvoiceIdEditRoute: AdminInvoiceInvoiceIdEditRoute,AdminInvoiceInvoiceIdPdfRoute: AdminInvoiceInvoiceIdPdfRoute,AdminInvoiceCreditMemoNewRoute: AdminInvoiceCreditMemoNewRoute,AdminWarehouseOrdersOrderIdRoute: AdminWarehouseOrdersOrderIdRoute,AdminCrmClientsIndexRoute: AdminCrmClientsIndexRoute,AdminCrmOpportunitiesIndexRoute: AdminCrmOpportunitiesIndexRoute,AdminInvoiceInvoiceIdIndexRoute: AdminInvoiceInvoiceIdIndexRoute,AdminInvoiceCreditMemoInvoiceIdEditRoute: AdminInvoiceCreditMemoInvoiceIdEditRoute,AdminInvoiceCreditMemoInvoiceIdIndexRoute: AdminInvoiceCreditMemoInvoiceIdIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,LoginRoute: LoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)